import { render, staticRenderFns } from "./reviewWork.vue?vue&type=template&id=1ae84cc6&scoped=true&"
import script from "./reviewWork.vue?vue&type=script&lang=js&"
export * from "./reviewWork.vue?vue&type=script&lang=js&"
import style0 from "./reviewWork.vue?vue&type=style&index=0&id=1ae84cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae84cc6",
  null
  
)

export default component.exports